import { WebMicrositePlatform } from './types';

export const MOBILE_MDGAP_BASE_WIDTH = 375;
export const MOBILE_NAV_BAR_HEIGHT = 44;
export const LITE_NAV_BAR_HEIGHT = 56;

export const MOBILE_MAX_COMPONENT_WIDTH = 600;
export const PC_MAX_COMPONENT_WIDTH = 960;

export const MODULAR_PAGE_PLATFORM_PC = 'pc';
export const MODULAR_PAGE_PLATFORM_RW = 'rw';
export const MODULAR_PAGE_PLATFORM_LITE = 'lite';
export const PREVIEW_MODULAR_PAGE_PLATFORM_MOBILE = 'mobile';

export const MODULAR_PAGE_REDUCER_NAME = 'modular_pages';
export const MICROSITE_EXTRA_REDUCER_NAME = 'microsite_extra';

const SECONDms = 1000;
export const DEFAULT_PAGE_CONTENT_TIMEOUT = 20 * SECONDms;

/**
 * derived from firebase custom performance trace (MicrositePageConfigAPI) of each platform
 * derivation method: last 90 days -> filter by country -> top 25 -> highest p95 -> ceil() -> minimum 5s
 */
export const PAGE_CONTENT_TIMEOUT_PLATFORM_MAP: {
  [key in WebMicrositePlatform]: number;
} = {
  /**
   * https://console.firebase.google.com/u/0/project/shopee-ad86f/performance/app/web:YmE1OGQ2NWMtNTQzNS00NTEyLTg5M2QtMDBhMWY4ZmFlZmU5/details/trace/DURATION_TRACE/MicrositePageConfigAPI/duration/duration
   * 21/09/2021: Netherlands: 2.57s
   */
  pc: 5 * SECONDms,
  /**
   * https://console.firebase.google.com/u/0/project/shopee-ad86f/performance/app/web:ZjRkMDM2YTQtMWFhZC00ZDc5LWI5NGQtYTFmODk3NmMyZmZm/details/trace/DURATION_TRACE/MicrositePageConfigAPI/duration/duration
   * 21/09/2021: Bangladesh: 2.5s
   */
  rw: 5 * SECONDms,
  /**
   * https://console.firebase.google.com/u/0/project/shopee-ad86f/performance/app/web:YmMzNzIyMDYtNGU2ZS00NWVkLWEyYmUtYTM0Mzk0OTc4YTJi/details/trace/DURATION_TRACE/MicrositePageConfigAPI/duration/duration
   * 21/09/2021: Indonesia: 2.53s
   */
  lite: 5 * SECONDms,
};
